import { Turbo } from "@hotwired/turbo-rails";

Turbo.StreamActions.job_profitability_report_stale = function jobProfitabilityReportStale() {
  const selector = this.getAttribute("target") || ".job-profitability";
  const root = document.querySelector(selector);
  if (!root) {
    return;
  }

  root.dataset.jobProfitabilityReportStale = "true";
};
